export const PROPERTIES = [
  {
    id: "p1",
    title: "Dholera Residential Plot — Sector R7",
    location: "Dholera SIR, Gujarat",
    price: "₹ 28 Lakh onwards",
    priceNumeric: 2800000,
    area: "1,800 sq.ft",
    type: "Residential Plot",
    category: "Investment",
    image:
      "https://images.unsplash.com/photo-1613490908677-22920f5c1d63?q=80&w=2070&auto=format&fit=crop",
    description:
      "Government-approved residential plot in the heart of Dholera Smart City Phase-1 development zone.",
    highlights: ["RERA Approved", "Clear Title", "Phase-1 Zone"],
  },
  {
    id: "p2",
    title: "Premium Commercial Land — TP-2",
    location: "ABCD Zone, Dholera",
    price: "₹ 95 Lakh onwards",
    priceNumeric: 9500000,
    area: "5,400 sq.ft",
    type: "Commercial",
    category: "High-Yield",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop",
    description:
      "Strategic commercial parcel near upcoming ABCD activation zone — ideal for retail, offices and mixed-use development.",
    highlights: ["Frontage Plot", "ABCD Zone", "High Appreciation"],
  },
  {
    id: "p3",
    title: "NA Agricultural Land — Highway Frontage",
    location: "Bhavnagar Highway, Dholera",
    price: "₹ 42 Lakh onwards",
    priceNumeric: 4200000,
    area: "1 Acre",
    type: "Agricultural Land",
    category: "Long-Term",
    image:
      "https://images.pexels.com/photos/8092437/pexels-photo-8092437.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "Highway-facing agricultural parcel with NA conversion potential, perfect for long-term wealth creation.",
    highlights: ["Highway Touch", "NA Possible", "Title Verified"],
  },
  {
    id: "p4",
    title: "Luxury Villa Plot — Riverside",
    location: "Sabarmati Riverfront, Dholera",
    price: "₹ 65 Lakh onwards",
    priceNumeric: 6500000,
    area: "3,200 sq.ft",
    type: "Residential Plot",
    category: "Premium",
    image:
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2070&auto=format&fit=crop",
    description:
      "Limited-inventory villa plots in a gated luxury enclave overlooking the Sabarmati riverfront greens.",
    highlights: ["Gated Community", "Riverfront", "Limited Inventory"],
  },
  {
    id: "p5",
    title: "Industrial Land Parcel — Activation Zone",
    location: "Dholera Industrial City",
    price: "₹ 1.85 Cr onwards",
    priceNumeric: 18500000,
    area: "10,800 sq.ft",
    type: "Industrial",
    category: "High-Yield",
    image:
      "https://images.pexels.com/photos/18285887/pexels-photo-18285887.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "Activation-ready industrial parcel inside DMIC corridor, well connected to expressways and ports.",
    highlights: ["DMIC Corridor", "Activation Ready", "Tax Benefits"],
  },
  {
    id: "p6",
    title: "Smart City Residential Plot — Sector R5",
    location: "Dholera SIR, Gujarat",
    price: "₹ 22 Lakh onwards",
    priceNumeric: 2200000,
    area: "1,200 sq.ft",
    type: "Residential Plot",
    category: "Entry-Level",
    image:
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2075&auto=format&fit=crop",
    description:
      "Entry-level investment plot in fast-developing Sector R5 of India's first greenfield smart city.",
    highlights: ["RERA Approved", "Affordable Entry", "Title Clear"],
  },
];

export const PROJECTS = [
  {
    id: "pr1",
    slug: "mayur-greenz-courtyard",
    title: "Mayur Greenz Courtyard",
    category: "Ultra Luxury Villa Project",
    location: "Dholera Smart City",
    propertyType: "3 BHK Ultra Luxurious Villas",
    highlight: "Assured Rental Income of ₹45,000 per Month for 7 Years",
    startingPrice: null,
    plotSize: null,
    totalUnits: null,
    overview:
      "Experience premium living inspired by timeless architecture and modern luxury. Mayur Greenz Courtyard offers beautifully designed villas in the heart of Dholera Smart City, combining comfort, elegance, and investment security.",
    benefits: [
      "Assured Rental Income",
      "NA, NOC & Title Clear",
      "Unit Plan Approved",
      "Premium Villa Community",
      "Smart City Location",
      "Long-Term Appreciation Potential",
    ],
    cta: "Schedule Site Visit",
    image:
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2075&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2075&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?q=80&w=2071&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2070&auto=format&fit=crop",
    ],
  },
  {
    id: "pr2",
    slug: "mayur-forest-villa",
    title: "Mayur Forest Villa",
    category: "Residential Villa Plots",
    location: "Dholera Smart City",
    propertyType: "Residential Villa Plots",
    highlight: "Starting From 134 Sq. Yards · ₹14 Lakhs Onwards",
    startingPrice: "₹14 Lakhs",
    plotSize: "Starting From 134 Sq. Yards",
    totalUnits: null,
    overview:
      "A nature-inspired residential development offering spacious villa plots surrounded by greenery. Designed for investors and families seeking peaceful living with future growth potential.",
    benefits: [
      "Nature-Centric Planning",
      "Spacious Plot Sizes",
      "Premium Community Development",
      "NA, NOC & Title Clear",
      "Unit Plan Approved",
      "Excellent Investment Opportunity",
    ],
    cta: "Book Your Plot",
    image:
      "https://images.unsplash.com/photo-1448630360428-65456885c650?q=80&w=2067&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1448630360428-65456885c650?q=80&w=2067&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=2032&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1542718610-a1d656d1884c?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1473773508845-188df298d2d1?q=80&w=2069&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1502175353174-a7a1b0e1a4f7?q=80&w=2070&auto=format&fit=crop",
    ],
  },
  {
    id: "pr3",
    slug: "mayur-ananta",
    title: "Mayur Ananta",
    category: "Mega Residential Plot Scheme",
    location: "Dholera Smart City",
    propertyType: "Residential Plots",
    highlight: "1491 Units · ₹11 Lakhs Onwards · Near Dholera SIR Boundary",
    startingPrice: "₹11 Lakhs",
    plotSize: null,
    totalUnits: "1491 Units",
    overview:
      "A large-scale residential plotting project strategically located near the Dholera SIR boundary. Designed to provide investors access to one of India's fastest-growing smart city developments.",
    benefits: [
      "Located Near Dholera SIR Boundary",
      "Mega Residential Development",
      "NA, NOC & Title Clear",
      "Unit Plan Approved",
      "Future Growth Corridor",
      "High Appreciation Potential",
    ],
    cta: "Reserve Your Plot",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1449844908441-8829872d2607?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1542621334-a254cf47733d?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1518780664697-55e3ad937233?q=80&w=2065&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1582407947304-fd86f028f716?q=80&w=2096&auto=format&fit=crop",
    ],
  },
];

export const COMMON_PROJECT_BENEFITS = [
  "Prime Dholera Smart City Location",
  "Government-Backed Smart City Development",
  "Verified Documentation",
  "Strong Future Appreciation Potential",
  "Residential & Investment Opportunities",
  "End-to-End Support from S Mahadeva Properties",
];

export const SERVICES = [
  {
    icon: "TrendingUp",
    title: "Investment Advisory",
    desc: "Strategic guidance on high-potential Dholera Smart City opportunities tailored to your investment goals.",
  },
  {
    icon: "Home",
    title: "Residential Property Sales",
    desc: "Curated residential plots and homes in government-approved smart city zones.",
  },
  {
    icon: "Building2",
    title: "Commercial Property Sales",
    desc: "Premium commercial land for retail, office and mixed-use development opportunities.",
  },
  {
    icon: "MapPin",
    title: "Site Visit Assistance",
    desc: "Complimentary, fully-organised Dholera site visits with expert on-ground guidance.",
  },
  {
    icon: "FileCheck2",
    title: "Documentation Support",
    desc: "End-to-end legal vetting, RERA verification and registration paperwork handled for you.",
  },
  {
    icon: "Handshake",
    title: "End-to-End Property Solutions",
    desc: "From discovery to deed — a single trusted partner for every step of your real estate journey.",
  },
];

export const WHY_DHOLERA = [
  {
    icon: "Cpu",
    title: "Smart City Vision",
    desc: "India's first greenfield smart city, designed ground-up with world-class urban planning.",
    span: "md:col-span-2",
  },
  {
    icon: "Landmark",
    title: "Government Infrastructure",
    desc: "Backed by Government of India & Gujarat under the DMIC initiative.",
  },
  {
    icon: "TrendingUp",
    title: "Growth Potential",
    desc: "Projected to be twice the size of Delhi, with multi-decade appreciation runway.",
  },
  {
    icon: "Factory",
    title: "Industrial Development",
    desc: "Dedicated SIR corridors, activation zones and global investor interest.",
    span: "md:col-span-2",
  },
  {
    icon: "ChartNoAxesCombined",
    title: "Long-Term Appreciation",
    desc: "Land values projected to compound over the next 15–20 years.",
  },
  {
    icon: "ShieldCheck",
    title: "Strategic Investment",
    desc: "RERA-approved, title-clear plots with government de-risking.",
  },
];

export const WHY_CHOOSE = [
  {
    icon: "BadgeCheck",
    title: "Trusted Advisory",
    desc: "10+ years of advising serious investors across PAN India.",
  },
  {
    icon: "ShieldCheck",
    title: "Verified Opportunities",
    desc: "Every plot we recommend is RERA-checked and title-verified.",
  },
  {
    icon: "Compass",
    title: "Professional Guidance",
    desc: "Investment plans aligned to your goals, horizon and risk profile.",
  },
  {
    icon: "BookOpen",
    title: "Market Knowledge",
    desc: "Deep, ground-level intelligence on Dholera micro-markets.",
  },
  {
    icon: "FileCheck2",
    title: "Documentation Support",
    desc: "Legal due-diligence and registration handled end-to-end.",
  },
  {
    icon: "Handshake",
    title: "End-to-End Assistance",
    desc: "A single point of contact — from first call to final possession.",
  },
];
